import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ApiEndPoint } from 'src/app/config/api-end-point';

@Component({
  selector: 'app-terms-and-condition',
  templateUrl: './terms-and-condition.component.html',
  styleUrls: ['./terms-and-condition.component.scss']
})
export class TermsAndConditionComponent implements OnInit {
  pageName: any;
  description: any;
  type: any;
  result: any;
  staticContentDetails: any;
  termsData: any;
  isLoading: boolean = true;
  documentOnly: boolean = false;
  sanitizedPdfUrl: SafeResourceUrl | null = null;
  

  constructor(
    private fb: FormBuilder, 
    public commonService: CommonService, 
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    
    // Check if this is a document-only view
    this.route.data.subscribe(data => {
      this.documentOnly = data.documentOnly === true;
    });
    
    this.getTerms();
  }
  
  getTerms() {
    this.isLoading = true;
    this.commonService.showSpinner();
    
    // Use the correct API endpoint from the config file
    this.commonService.getApi(ApiEndPoint.termsAndConditions, 0).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.termsData = res['result'];
          this.setDocumentTypeFlags();
          this.commonService.hideSpinner();
          this.isLoading = false;
        } else {
          this.commonService.hideSpinner();
          this.isLoading = false;
          this.commonService.errorToast(res.responseMessage);
        }
      }, 
      err => {
        this.commonService.hideSpinner();
        this.isLoading = false;
        this.commonService.warningToast(err['error']['responseMessage']);
      }
    );
  }

  setDocumentTypeFlags() {
    const url = this.termsData?.documentUrl?.toLowerCase() || '';
    console.log('DEBUG: Document URL:', this.termsData?.documentUrl);
    console.log('DEBUG: isSupportedDocument:', this.isSupportedDocument());
    console.log('DEBUG: isOfficeDocument:', this.isOfficeDocument());
    console.log('DEBUG: isImageDocument:', this.isImageDocument());
    console.log('DEBUG: isTxtDocument:', this.isTxtDocument());
    // FORCE PDF logic for all documents for testing
    let pdfUrl = this.termsData.documentUrl;
    if (pdfUrl && pdfUrl.endsWith('.pdf') && !pdfUrl.includes('#')) {
      pdfUrl += '#view=FitH';
    }
    this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
  }

  // Helper method to check if a URL is from S3
  private isS3Url(url: string): boolean {
    if (!url) return false;
    
    return url.includes('amazonaws.com') || 
           url.includes('s3.') || 
           url.includes('s3-');
  }

  // Determine if the document is a supported type (PDF or Text)
  isSupportedDocument(): boolean {
    if (!this.termsData || !this.termsData.documentUrl) return false;
    
    const url = this.termsData.documentUrl.toLowerCase();
    const documentType = this.termsData.documentType ? this.termsData.documentType.toLowerCase() : '';

    return url.endsWith('.pdf') || documentType.includes('pdf');
  }

  // Determine if the document is an Office document (Word, Excel, PowerPoint)
  isOfficeDocument(): boolean {
    if (!this.termsData || !this.termsData.documentUrl) return false;
    
    const url = this.termsData.documentUrl.toLowerCase();
    const officeExtensions = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
    
    return officeExtensions.some(ext => url.endsWith(ext)) || 
           (this.termsData.documentType && 
            (this.termsData.documentType.toLowerCase().includes('word') || 
             this.termsData.documentType.toLowerCase().includes('excel') || 
             this.termsData.documentType.toLowerCase().includes('powerpoint') ||
             this.termsData.documentType.toLowerCase().includes('office')));
  }
  
  // New getter to provide safe URL for Office documents
  get safeOfficeDocumentUrl(): SafeResourceUrl {
    if (this.termsData && this.termsData.documentUrl) {
      const encodedUrl = encodeURIComponent(this.termsData.documentUrl);
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://docs.google.com/viewer?url=${encodedUrl}&embedded=true`
      );
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl('');
  }

  isImageDocument(): boolean {
    if (!this.termsData || !this.termsData.documentUrl) return false;
    const url = this.termsData.documentUrl.toLowerCase();
    return ['.jpg', '.jpeg', '.png', '.gif'].some(ext => url.endsWith(ext));
  }

  isTxtDocument(): boolean {
    if (!this.termsData || !this.termsData.documentUrl) return false;
    const url = this.termsData.documentUrl.toLowerCase();
    return url.endsWith('.txt');
  }

  isOtherDocument(): boolean {
    if (!this.termsData || !this.termsData.documentUrl) return false;
    const url = this.termsData.documentUrl.toLowerCase();
    return !this.isSupportedDocument() && !this.isImageDocument() && !this.isOfficeDocument() && !this.isTxtDocument();
  }

  // Close the document view and return to the regular view
  closeDocumentView(): void {
    if (window.opener) {
      window.close(); // Close the tab if opened in a new tab
    } else {
      this.router.navigate(['/terms-and-condition']); // Navigate back to regular view
    }
  }

  openPdfInNewTab() {
    if (this.termsData?.documentUrl) {
      window.open(this.termsData.documentUrl, '_blank');
    }
  }
}



